import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/analytics';
import './plugins/currency';
import './setup/removeWorkerService';
import i18n from './setup/lang/i18n';

// firebase init goes here
var config = {
    apiKey: process.env.VUE_APP_apiKey,
    authDomain: process.env.VUE_APP_authDomain,
    databaseURL: process.env.VUE_APP_databaseURL,
    projectId: process.env.VUE_APP_projectId,
    storageBucket: process.env.VUE_APP_storageBucket,
    messagingSenderId: process.env.VUE_APP_messagingSenderId,
    appId: process.env.VUE_APP_appId,
    measurementId: process.env.VUE_APP_measurementId
};
firebase.initializeApp(config);
firebase.analytics();

Vue.config.productionTip = false;
Vue.config.devtools = process.env.VUE_APP_devtools;

let app;

if (navigator && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then(
        function (registrations) {
            for (let registration of registrations) {
                registration.unregister();
            }
        });
}

function createApp() {
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            store,
            i18n,
            render: h => h(App)
        });
    }
}

firebase.auth().onAuthStateChanged(user => {
    if (!user) {
        createApp();
        return;
    }

    let userStored = {
        name: user.displayName,
        email: user.email,
        uid: user.uid,
        photoURL: user.photoURL
    };
    store.dispatch("fetchUser", userStored);

    let db = firebase.firestore();
    let usersRef = db.collection("users");
    // firebase.auth().currentUser.getIdToken(true), 

    usersRef.doc(user.uid).get().then(function (data) {
        if (!data.exists) {
            return;
        }

        let userStored = Object.assign({
            uid: user.uid
        }, data.data());
        store.dispatch("fetchUser", userStored);
    }).catch(function (error) {
        console.log('Can not get user: ', error);
    });

    if (store.state.user && store.state.user.data) {
        createApp();
        return;
    }

    createApp();
});